import { errorMessageFromFormErrors } from 'shared';
import toastError from './toastError';
// Generate a flash error message for form submission failures
export default function flashSubmitFailure(errors, dispatch, submitError) {
    const errorMessage = errorMessageFromFormErrors(errors, submitError);
    errorMessage && toastError(errorMessage);
}
